import React from 'react';
import { Navigate } from 'react-router-dom';
import NotFound from './pages/Error/NotFound';
import MainPage from './pages/auth/MainPage/MainPage';
import Products from './pages/auth/Products/MainPage';
import LoginPage from './pages/auth/Login/LoginPage';
import Email from './pages/auth/Login/Email';
import ForgotPassword from './pages/auth/Login/ForgotPassword';
import SuccessEmail from './pages/auth/Login/Welcome';
import ResetSuccess from './pages/auth/Login/ResetStatus';
import TrainerLogin from './pages/auth/TrainerLogin/Login';
import RegisterPage from './pages/auth/Register/RegisterPage';
import WelcomePage from './pages/auth/Welcome/Welcome';
import UnSubscribe from './pages/UnSubscribe/Success';
import URLConnectivity from './pages/URLConnectivity/URLConnectivity';

import 'src/assets/styles/tailwind.css';

const authroutes = [
  {
    path: '/',    
    children: [
      { path: '', element: <MainPage /> },
      { path: 'products', element: <Products /> },   
      { path: ':orgname', element: <TrainerLogin /> },  
      { path: 'admin', element: <LoginPage /> },
      { path: 'forgotpassword', element: <Email /> },  
      { path: 'emailsend', element: <SuccessEmail /> },
      { path: 'passwdresetsuccess', element: <ResetSuccess /> },
      { path: 'resetpassword/:uidb64/:token', element: <ForgotPassword /> }, 
      { path: 'register', element: <RegisterPage /> },
      { path: 'welcome', element: <WelcomePage /> },
      { path: 'connectivitytest', element: <URLConnectivity /> },
      { path: 'unsubscribe', element: <UnSubscribe /> },
      { path: '404', element: <NotFound /> },
      { path: '*', element: <Navigate to="/admin" /> },
      { path: 'login', element: <Navigate to="/admin" /> },
    ]
  }
];

export default authroutes;
